import { render, staticRenderFns } from "./inspectPay.vue?vue&type=template&id=64c4ea07&scoped=true"
import script from "./inspectPay.vue?vue&type=script&lang=js"
export * from "./inspectPay.vue?vue&type=script&lang=js"
import style0 from "./inspectPay.vue?vue&type=style&index=0&id=64c4ea07&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c4ea07",
  null
  
)

export default component.exports